module.exports = __webpack_public_path__ + "media/38_Long.7d1cbde4.mp3";